import { render, staticRenderFns } from "./ParentHome.vue?vue&type=template&id=36a13287&scoped=true"
import script from "./ParentHome.vue?vue&type=script&lang=js"
export * from "./ParentHome.vue?vue&type=script&lang=js"
import style0 from "./ParentHome.vue?vue&type=style&index=0&id=36a13287&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a13287",
  null
  
)

export default component.exports